import React, { useState, useEffect } from 'react';
import { PageContainer, Icons } from 'components';
import { CommonProvider } from 'providers';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useQuery } from 'hooks';
import Content from './components/Content';
import SubsetServices from '../../services/SubsetServices';
import { useParams, useLocation } from 'react-router-dom';
import BranchSeparateReportSummary from './components/BranchSeparateReportSummary';
import { constBreadCrumbsTitle } from 'utility';

const BranchTransAction = () => {
  const [branchData, setBranchData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [cameFromGuilds, setCameFromGuilds] = useState(false);
  const params = useParams();
  const query = useQuery();
  const location = useLocation();
  const [isImprest, setIsImprest] = useState(null);
  const [dateServer, setDateServer] = useState({ start: null, end: null });
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  useEffect(() => {
    if (query) {
      const isFromGuild = query?.get('fromGuilds');
      if (isFromGuild) setCameFromGuilds(true);
    }
  }, [query]);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const imprest = searchParams.get('imprest');
    setIsImprest(imprest ? true : false);
    getBranchDetail();
    getDateFromSrver();
  }, []);
  const getBranchDetail = () => {
    setLoading(true);
    SubsetServices.getBranch({ businessId: params.id, offset: 0, size: 1 })
      .then((res) => {
        const branchData = res.result[0];
        setBranchData(branchData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  /**
   * دریافت تاریخ  فیلترها از سرویس
   */
  const getDateFromSrver = () => {
    const model = {
      //accountId: params.id,
      businessId: params.id,
    };
    SubsetServices.reportGetDateFromServer(model)
      .then((res) => {
        setDateServer({
          start: res.result.rows[0].cols[11],
          end: res.result.rows[0].cols[7],
        });
        setIsLoadingPage(false);
      })
      .catch((error) => {
        setIsLoadingPage(false);
      });
  };

  const hint =
    'در این بخش می‌توانید گزارش کلیه تراکنش‌های مالی حساب‌های تفصیلی و حساب دیجیتال خود را مشاهده نمایید. قابلیت فیلتر کردن روی فیلدهای مختلف و دریافت فایل خروجی نیز وجود دارد.';
  const delay = 'صورتحساب زیر با ۵ دقیقه تاخیر نمایش داده می‌شود.';
  const getKeyBreadCrumbsWithUrl = () => {
    if (isImprest === null || isImprest === undefined) return null;

    return isImprest === true
      ? constBreadCrumbsTitle.IMPREST_TRANSACTIONS
      : constBreadCrumbsTitle.BRANCH_TRANSACTIONS;
  };
  return (
    <>
      <PageContainer
        title={'صورت حساب تراکنش ' + (branchData?.name || '')}
        loading={loading || isLoadingPage}
        breadcrumbs={getKeyBreadCrumbsWithUrl()}
        description={delay}
        meta={
          <Button
            // className={classes.cardHeaderButton}
            onClick={() => navigate(-1)}
            color="primary"
            endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
            variant="outlined"
          >
            بازگشت
          </Button>
        }
      >
        <CommonProvider>
          <Content dataBusiness={branchData} dateServer={dateServer} />
        </CommonProvider>
        {/* <Content dataBusiness={branchData} /> */}
      </PageContainer>
      <>
        <BranchSeparateReportSummary id={params.id} />
      </>
    </>
  );
};
// const BranchTransAction = () => {
//   return <>hiii</>;
// };

export default BranchTransAction;
